import { Box, Divider, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import { Images } from "../../assets/common";
import {
  fullName,
  getErrorString,
  getUserDetail,
  getUserId,
  isOwnerId,
  truncate,
} from "../../constants/function";
import { SocketContext } from "../../context/socket";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import cookieStorage from "../../services/cookie-storage";
import OutsideClickHandler from "react-outside-click-handler";
import Picker from "emoji-picker-react";
import Message from "../Chat/Message";
import ChatInput from "../Chat/ChatInput";
import ChatUserSearch from "./chatUserSearch";
import ApiService from "../../services/api-service";
import notifier from "../Notifier";
import { getBalance } from "../../asyncAction/asyncBalance";
import TipPopup from "../TipPopup";
import NoData from "../Nodata";
import Loader from "../Loader";
import { hideChat } from "./../../action/chat";
import ChatTip from "./../../components/Chat/ChatTip";
import OnlineUsers from "../Chat/OnlineUsers";
import Online from "./../../components/Chat/online";
import ChatMoreData from "../Chat/ChatMoreData";
import NftList from "./nftList";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { startStream } from "./../../action/stream";
import StreamingDetailPoup from "../Stream/StreamingDetailPoup";
import { useTranslation } from "react-i18next";
// Cache for chat data to avoid reloading
const chatDataCache = {
  data: null,
  timestamp: null,
  userId: null,
  CACHE_DURATION: 5 * 60 * 1000 // 5 minutes
};

// Memoized chat item component for better performance
const ChatUserItem = React.memo(({ topChat, index, onClick, userId }) => {
  const avatarSrc = useMemo(() => {
    if (topChat["PlaylistroomId"] && topChat["playlistDetails"]) {
      return topChat["playlistDetails"]["GIF"]
        ? topChat["playlistDetails"]["GIF"]["filePath"]
        : topChat["playlistDetails"]["thumbnailImg"]
        ? topChat["playlistDetails"]["thumbnailImg"]["filePath"]
        : Images.musicImg;
    }
    return topChat["otherUser"] && topChat["otherUser"]["profileImg"]
      ? topChat["otherUser"]["profileImg"]["filePath"]
      : Images.musicImg;
  }, [topChat]);

  const displayName = useMemo(() => {
    return topChat["PlaylistroomId"]
      ? truncate(topChat["playlistDetails"]["title"], 18)
      : truncate(fullName(topChat["otherUser"]), 18);
  }, [topChat]);

  const unseenCount = useMemo(() => {
    if (topChat["count"] && !topChat["PlaylistroomId"]) {
      return topChat["count"];
    }
    if (topChat["PlaylistroomId"] && topChat["unseen"] && topChat["unseen"][userId]) {
      return topChat["unseen"][userId];
    }
    return null;
  }, [topChat, userId]);

  return (
    <Box
      className="__chat_user_box_user"
      onClick={() => onClick(topChat, index)}
    >
      {unseenCount ? (
        <Box className="__chat_user_online_count">
          {unseenCount}
        </Box>
      ) : null}
      <img
        className="avatar"
        src={avatarSrc}
        alt={displayName}
      />
      <Box flex={1}>
        <Typography className="_fade-text-80 fs-14 font-weight-500">
          {displayName}
        </Typography>
      </Box>
      {topChat["otherUser"] && topChat["otherUser"]["isOnline"] ? (
        <Box
          sx={{
            position: "absolute",
            width: "10px",
            height: "10px",
            background: "var(--primary-color, #FFEE20)",
            right: "22px",
            top: "18px",
            borderRadius: "50%",
          }}
        />
      ) : null}
    </Box>
  );
});

export default function DirectChat(props) {
  console.log('[Chat Performance] DirectChat component mounting', {
    props,
    timestamp: new Date().toISOString()
  });
  
  const { t } = useTranslation("common");
  const { isStream } = useSelector((state) => state.stream);
  const [isStreamingPopup, setIsStreamingPopup] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const songs = useSelector((state) => state.songs);
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const token = cookieStorage.getCookie("Authorization");
  const [typing, setTyping] = React.useState(false);
  const socket = useContext(SocketContext).Socket;
  const [message, setMessage] = useState("");
  const [openEmoji, setOpenEmoji] = useState(false);
  const [roomId, setRoomId] = useState(null);
  const [openUser, setOpenUser] = useState(false);
  const [openTip, setOpenTip] = React.useState(false);
  const [openPlaylistTip, setOpenPlaylistTip] = React.useState(false);
  const [userName, setUserName] = React.useState(null);
  const [chatIndex, setChatIndex] = React.useState(null);
  const online = useRef(null);
  let roomid = useRef(null);
  const topuser = useRef([]);
  const senderUserId = useRef(null);
  const userId = getUserId();
  const [loading, setLoading] = useState(false);
  const [topChats, setTopChats] = useState([]);
  const [newMessage, setNewMessage] = useState({});
  const [newUser, setNewUser] = useState({});
  const [load, setLoad] = useState(false);
  const [playlistRoomId, setPlaylistRoomId] = useState(null);
  const isPlaylistChat = useRef(null);
  const [showUsers, setShowUsers] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [more, setMore] = useState(false);
  const [showNft, setShowNft] = useState(false);
  const [status, setStatus] = useState(null);
  const [blockedBy, setBlockedBy] = useState(null);
  const onEmojiClick = (emojiObject) => {
    if (emojiObject && emojiObject.emoji) {
      setChosenEmoji(emojiObject);
      setMessage((prevMessage) => prevMessage + emojiObject.emoji);
    }
  };
  useEffect(() => {
    // socket.on("notifyDirectTyping", (msg) => {
    //   if (
    //     msg &&
    //     msg["senderUserId"] &&
    //     msg["senderUserId"] !== getUserId() &&
    //     msg["roomId"] === roomid.current
    //   ) {
    //     setTyping(msg["senderUserId"]);
    //     setTimeout(() => setTyping(false), 500);
    //   }
    // });
    // socket.on("notifyTyping", (msg) => {
    //   if (
    //     msg &&
    //     msg["senderUserId"] &&
    //     msg["senderUserId"] !== getUserId() &&
    //     msg["roomId"] === roomid.current
    //   ) {
    //     setTyping(msg["senderUserId"]);
    //     setTimeout(() => setTyping(false), 500);
    //   }
    // });
    socket.on("id", (msg) => {
      console.log('[DM Chat] Socket "id" event received', {
        msg,
        currentRoomId: roomid.current,
        senderUserId: senderUserId.current,
        willSetRoom: msg && !roomid.current && msg["senderUserId"] === senderUserId.current
      });

      if (
        msg &&
        !roomid.current &&
        msg["senderUserId"] === senderUserId.current
      ) {
        console.log('[DM Chat] Setting roomId from socket', msg["roomId"]);
        roomid.current = msg["roomId"];
        setRoomId(msg["roomId"]);
        setStatus(msg["status"]);
        setBlockedBy(msg?.blockedBy || null);
        for (let index = 0; index < topuser.current.length; index++) {
          const element = topuser.current[index];
          if (!element.roomId) {
            topuser.current[index].roomId = msg["roomId"];
            break;
          }
        }
        // if (
        //   topuser.current.length > 0 &&
        //   !topuser.current[topuser.current.length - 1]["roomId"]
        // ) {
        //   const topchat = topuser.current;
        //   topchat[topuser.current.length - 1]["roomId"] = msg["roomId"];
        //   topchat[topuser.current.length - 1]["ChatroomId"] = msg["roomId"];
        //   setTopChats([...topchat]);
        // }
      }
    });
    socket.on("onlineuser", (u) => {
      setOnlineUsers([...u]);
    });

    senderUserId.current = props["senderUserId"];
  }, [socket, props["senderUserId"]]);

  // Seting chat history users online offline status
  React.useEffect(() => {
    console.log('[Chat Performance] DirectChat useEffect for loading chats', {
      topChatsLength: topChats.length,
      userId,
      timestamp: new Date().toISOString()
    });
    
    if (topChats.length === 0 && userId) {
      getGroupChat(userId);
    }

    socket.on("message_received", (msg) => {
      const userId = getUserId();
      if (msg.gift && msg["user"]._id === userId) return;
      
      // Invalidate cache when new message arrives
      chatDataCache.timestamp = null;
      const temp = topuser.current;
      const found = topuser.current.filter(
        (u) => msg["roomId"] === u["roomId"]
      );
      if (found.length === 0 && msg["senderUserId"] === getUserId()) {
        const user = getUserDetail();
        const newUser = {
          ChatroomType: "direct",
          ChatroomId: msg["roomId"],
          otherUser: msg["user"],
          recieverId: msg["user"]["_id"],
          roomId: msg["roomId"],
          online: true,
          count: 1,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          userDetails: msg["user"],
        };
        // const topchat = topChats;
        // topchat.push(newUser);
        newUser["otherUser"]["isOnline"] = true;
        topuser.current.unshift(newUser);
        setTopChats([...topuser.current]);
      } else {
        for (let index = 0; index < topuser.current.length; index++) {
          if (
            topuser.current[index]["roomId"] === msg["roomId"] &&
            msg["user"]["_id"] !== senderUserId.current
          ) {
            temp[index]["msgId"] = msg["_id"];
            temp[index]["count"] = temp[index]["count"]
              ? temp[index]["count"] + 1
              : 1;
            temp[index]["otherUser"]["isOnline"] = true;
            setTopChats([...temp]);
            break;
          }
        }
      }
    });
    socket.on("received", (msg) => {
      const temp = topuser.current;
      const found = topuser.current.filter(
        (u) => msg["roomId"] === u["roomId"]
      );
      if (
        found.length === 0 &&
        msg["senderUserId"] === getUserId() &&
        !msg["livestreamMessage"]
      ) {
        const user = getUserDetail();
        const newUser = {
          otherUser: msg["user"],
          recieverId: msg["user"]["_id"],
          roomId: msg["roomId"],
          online: true,
          count: 1,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          userDetails: msg["user"],
        };
        // const topchat = topChats;
        // topchat.push(newUser);

        topuser.current.push(newUser);
        setTopChats([...topuser.current]);
      } else {
        for (let index = 0; index < topuser.current.length; index++) {
          if (
            topuser.current[index]["roomId"] === msg["roomId"] &&
            msg["roomId"] !== roomid.current &&
            !msg["livestreamMessage"]
          ) {
            temp[index]["msgId"] = msg["_id"];
            temp[index]["unseen"][userId] = temp[index]["unseen"][userId]
              ? temp[index]["unseen"][userId] + 1
              : 1;
            // temp[index]["online"] = true;
            setTopChats([...temp]);
            break;
          }
        }
      }
    });
    // socket.on("online_direct", (users) => {
    //   const found = users.filter((u) => u["user"]["_id"] !== getUserId());
    //   if (
    //     found.length > 0 &&
    //     topuser.current.length > 0 &&
    //     users.length &&
    //     topuser.current
    //   ) {
    //     const temp = topuser.current;
    //     for (let i = 0; i < topuser.current.length; i++) {
    //       for (let index = 0; index < users.length; index++) {
    //         if (
    //           topuser.current[i]["otherUser"]["_id"] ===
    //           users[index]["user"]["_id"]
    //         ) {
    //           temp[i]["otherUser"]["isOnline"] = true;
    //           // temp[i]["online"] = users[index]["onlineStatus"];
    //           online.current = users[index]["ChatroomId"];
    //           setTopChats([...temp]);
    //           break;
    //         }
    //       }
    //       setTopChats([...temp]);
    //     }
    //   }
    // });
    //making user offline in chat history
    socket.on("user-disconnected", (user) => {
      if (topuser.current) {
        for (let index = 0; index < topuser.current.length; index++) {
          const u = topuser.current[index];
          if (
            u["ChatroomType"] === "direct" &&
            u["otherUser"]["_id"] === user
          ) {
            const users = topuser.current;
            online.current = null;
            users[index]["otherUser"]["isOnline"] = false;
            setTopChats([...users]);
            topuser.current = users;
            break;
          }
        }
      }
    });

    //making user online in chat history
    socket.on("user_connected", (user) => {
      if (topuser.current) {
        for (let index = 0; index < topuser.current.length; index++) {
          const u = topuser.current[index];
          if (
            u["ChatroomType"] === "direct" &&
            u["otherUser"]["_id"] === user
          ) {
            const users = topuser.current;
            online.current = users[index]["ChatroomId"];
            users[index]["otherUser"]["isOnline"] = true;
            setTopChats([...users]);
            topuser.current = users;
            break;
          }
        }
      }
    });
    //realtime blocking user if other user blocks the user in DM or group chat
    socket.on("blocked", (data) => {
      const curentUser = getUserId();
      if (
        (data.userId === curentUser && roomid.current === data.roomId) ||
        data.userId === curentUser
      ) {
        setStatus(data["status"]);
      }
      if (topuser.current && topuser.current.length) {
        for (let index = 0; index < topuser.current.length; index++) {
          const u = topuser.current[index];
          if (
            u["ChatroomType"] === "playlist" &&
            data["roomId"] === topuser.current[index]?.ChatroomId
          ) {
            const users = topuser.current;
            if (
              data.status === "blocked" &&
              users[index].blockList.indexOf(data.userId) < 0
            )
              users[index].blockList.push(data.userId);
            else if (
              data.status === "blocked" &&
              users[index].blockList.indexOf(data.userId) >= 0
            ) {
              const blockIndex = users[index].blockList;
              users[index].blockList.splice(blockIndex, 1);
            }
            setTopChats([...users]);
            topuser.current = users;
            break;
          }
        }
      }
    });
  }, [socket]);
  React.useEffect(() => {
    console.log('[DM Chat] useEffect triggered for joining chat', {
      timeStamp: props["timeStamp"],
      playlistroomId: props["playlistroomId"],
      senderUserId: props["senderUserId"],
      artistChat: props?.artistChat
    });

    if (
      (props["timeStamp"] && !props["playlistroomId"]) ||
      (props["senderUserId"] && props?.artistChat)
    ) {
      //NOTE: joining direct chat
      console.log('[DM Chat] Joining direct chat, emitting joinDirect event', {
        userId,
        senderUserId: props["senderUserId"]
      });
      roomid.current = null;
      setRoomId(null);
      isPlaylistChat.current = false;
      socket.emit("joinDirect", {
        JWT: token,
        roomId: userId,
        senderUserId: props["senderUserId"],
      });
    } else if (props["timeStamp"] && props["playlistroomId"]) {
      //NOTE: joining playlist chat
      console.log('[DM Chat] Joining playlist chat', props["playlistroomId"]);
      setRoomId(props["playlistroomId"]);
      roomid.current = props["playlistroomId"];
      isPlaylistChat.current = true;
      getBlockedUserOfPlaylist(props["playlistroomId"]);
      socket.emit("join", { JWT: token, roomId: props["playlistroomId"] });
    }
  }, [props["timeStamp"], props["senderUserId"] && props?.artistChat]);
  useEffect(() => {
    return () => {
      if (isPlaylistChat) {
        socket.emit("forceDisconnect", {
          JWT: token,
          senderUserId: getUserId(),
          roomId: roomid.current,
        });
      }
      setMessage("");
      setOnlineUsers([]);
      setNewUser({});
      setPlaylistRoomId(null);
      setNewMessage({});
      setTopChats({});
      // before the component is destroyed
      // unbind all event handlers used in this component
      // before the component is destroyed
      // unbind all event handlers used in this component
    };
  }, []);

  const handleTip = async (amount, id, type, currency) => {
    if (amount) {
      setOpenTip(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = isPlaylistChat.current
          ? await ApiService.TIP_PLAYLIST(payload)
          : await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        // setUserName(null);
        dispatch(getBalance());

        // NOTE Tip message now handled by backend
        // const user = getUserDetail();

        // if (isPlaylistChat.current) {
        //   const msg = {
        //     roomId: roomid.current,
        //     senderUserId: senderUserId.current,
        //     message: `${fullName(
        //       user
        //     )} has tipped ${amount} ${currency.toUpperCase()} `,
        //     _id: userId,
        //     JWT: token,
        //     type: "tip",
        //   };
        //   socket.emit("chat_message", msg);
        // } else {
        //   const userData = getUserDetail();
        //   const msg = {
        //     roomId: roomid.current,
        //     senderUserId: senderUserId.current,
        //     message: `${fullName(
        //       user
        //     )} has tipped ${amount} ${currency.toUpperCase()} `,
        //     _id: userData._id,
        //     JWT: token,
        //     type: "tip",
        //   };
        //   msg["user"] = {
        //     firstName: userData["firstName"],
        //     lastName: userData["lastName"],
        //     profileImg: userData["profileImg"],
        //     _id: userData["_id"],
        //   };
        //   msg["_id"] = new Date().getTime();
        //   msg["createdAt"] = new Date();
        //   socket.emit("send", msg);
        //   setNewMessage({ ...msg });
        // }
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const handleSelection = (senderId) => {
    setOpenUser(false);
  };
  const addNewUser = (chat, playlistroomId) => {
    setNewUser(chat);
    if (!playlistroomId) {
      const found = topuser.current.filter(
        (u) => u["otherUser"] && u["otherUser"]["_id"] === chat["_id"]
      );
      if (found.length > 0) {
        return;
      } else {
        const user = getUserDetail();
        const newUser = {
          ChatroomType: "direct",
          otherUser: {
            firstName: chat["firstName"],
            lastName: chat["lastName"],
            profileImg: chat["profileImg"],
            isOnline: chat["isOnline"],
            _id: chat["_id"],
          },
          recieverId: chat["_id"],
          roomId: null,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          userDetails: chat,
        };
        // const topchat = topChats;
        // topchat.push(newUser);
        // setTopChats([...topchat]);
        topuser.current.unshift(newUser);
        // online.current = chat["_id"];
        setTopChats([...topuser.current]);
        setChatIndex(0);
      }
    } else {
      const found = topuser.current.filter(
        (u) => u["PlaylistroomId"] === chat["_id"]
      );
      if (found.length > 0) {
        const index = topuser.current.findIndex(
          (el) => el.PlaylistroomId === chat._id
        );
        setChatIndex(index);
        return;
      } else {
        const user = getUserDetail();
        const newUser = {
          otherUser: {},
          recieverId: chat["_id"],
          roomId: null,
          senderDetail: {
            firstName: user["firstName"],
            lastName: user["lastName"],
            profileImg: user["profileImg"],
            _id: user["_id"],
          },
          blockList: [],
          ChatroomId: chat["_id"],
          ChatroomType: "playlist",
          PlaylistroomId: chat["_id"],
          playlistDetails: chat,
          onlineStatus: true,
          roomId: chat["_id"],
          unseen: null,
          userDetails: chat,
        };
        // const topchat = topChats;
        // topchat.push(newUser);
        // setTopChats([...topchat]);
        if (newUser?.playlistDetails?.playlistNftDetails?.owner)
          newUser.playlistDetails.owner =
            newUser.playlistDetails.playlistNftDetails.owner;
        if (newUser?.playlistDetails)
          newUser.nftDetails = {
            onAuction: newUser.playlistDetails.playlistNftDetails.onAuction,
            onSale: newUser.playlistDetails.playlistNftDetails.onSale,
          };
        topuser.current.unshift(newUser);
        setTopChats([...topuser.current]);
        setChatIndex(0);
      }
    }
  };
  const getGroupChat = async (userId) => {
    const startTime = performance.now();
    console.log('[Chat Performance] getGroupChat started', {
      userId,
      timestamp: new Date().toISOString()
    });
    
    // Validate userId before making API call
    if (!userId || userId === 'undefined' || userId === 'null') {
      console.warn('[Chat] Invalid userId, skipping chat data fetch:', userId);
      setLoad(false);
      return;
    }
    
    // Check global cache first (from preload)
    const now = Date.now();
    if (window.__chatDataCache && 
        window.__chatDataCache.userId === userId && 
        window.__chatDataCache.timestamp && 
        (now - window.__chatDataCache.timestamp) < chatDataCache.CACHE_DURATION) {
      console.log('[Chat Performance] Using preloaded chat data', {
        age: now - window.__chatDataCache.timestamp,
        cachedChats: window.__chatDataCache.data.length
      });
      setTopChats(window.__chatDataCache.data);
      topuser.current = [...window.__chatDataCache.data];
      chatDataCache.data = window.__chatDataCache.data;
      chatDataCache.timestamp = window.__chatDataCache.timestamp;
      chatDataCache.userId = userId;
      setLoad(false);
      return;
    }
    
    // Check local cache
    if (chatDataCache.data && 
        chatDataCache.userId === userId && 
        chatDataCache.timestamp && 
        (now - chatDataCache.timestamp) < chatDataCache.CACHE_DURATION) {
      console.log('[Chat Performance] Using cached chat data', {
        age: now - chatDataCache.timestamp,
        cachedChats: chatDataCache.data.length
      });
      setTopChats(chatDataCache.data);
      topuser.current = [...chatDataCache.data];
      setLoad(false);
      return;
    }
    
    try {
      setLoad(true);
      console.log('[DM Chat] Starting API call to GROUP_CHAT_V2', { userId, timestamp: new Date().toISOString() });

      // Add timeout warning
      const timeoutWarning = setTimeout(() => {
        console.warn('[DM Chat] API call taking longer than 5 seconds - possible backend issue');
      }, 5000);

      const response = await ApiService.GROUP_CHAT_V2(userId);
      clearTimeout(timeoutWarning);

      console.log('[Chat Performance] GROUP_CHAT_V2 API response received', {
        duration: performance.now() - startTime,
        oneToOneChatCount: response["result"]["oneToOneChatData"]?.length || 0,
        playlistChatCount: response["result"]["playlistChat"]?.length || 0,
        fullResponse: response
      });
      
      const oneToOneChatData = response["result"]["oneToOneChatData"] || [];
      const playlistChat = response["result"]["playlistChat"] || [];

      // Process data in batches for better performance
      const allChats = [...oneToOneChatData, ...playlistChat];
      
      // Set initial batch immediately for faster perceived loading
      if (allChats.length > 10) {
        setTopChats(allChats.slice(0, 10));
        
        // Load rest after a short delay
        setTimeout(() => {
          setTopChats(allChats);
          topuser.current = [...allChats];
        }, 100);
      } else {
        setTopChats(allChats);
        topuser.current = [...allChats];
      }
      
      // Update both local and global cache
      chatDataCache.data = allChats;
      chatDataCache.timestamp = Date.now();
      chatDataCache.userId = userId;
      
      // Update global cache for other components
      window.__chatDataCache = {
        data: allChats,
        timestamp: Date.now(),
        userId: userId
      };
      
      setLoad(false);
      console.log('[Chat Performance] getGroupChat completed', {
        totalDuration: performance.now() - startTime,
        totalChats: allChats.length
      });
    } catch (error) {
      console.error('[Chat Performance] getGroupChat error', error);
      console.error("Error loading chat data:", error);
      notifier.error("Failed to load chat messages. Please try again.");
      setLoad(false);
      setTopChats([]);
      topuser.current = [];
    }
  };

  const handleTilteClick = () => {
    if (isPlaylistChat.current) history.push(`/app/Music/${roomid.current}`);
    else history.push(`/app/ArtistProfile/${newUser["_id"]}`);
  };
  useEffect(() => {}, [status]);
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      setStatus(response?.result?.isBlocked ? "blocked" : "active");
    } catch (error) {}
  };

  // Memoized chat item click handler
  const handleChatItemClick = React.useCallback((topChat, index) => {
    if (chatIndex === index) {
      return;
    }

    setNewUser(topChat["otherUser"] ? topChat["otherUser"] : {});
    online.current = topChat["otherUser"] ? topChat["ChatroomId"] : null;
    setChatIndex(index);
    
    const temp = topChats;
    temp[index]["count"] = undefined;
    if (temp[index]["unseen"]) temp[index]["unseen"][userId] = 0;
    setTopChats([...temp]);
    
    setRoomId(null);
    const userName = topChat["PlaylistroomId"]
      ? topChat["playlistDetails"]["title"]
      : fullName(topChat["otherUser"]);
    const userid = topChat["PlaylistroomId"]
      ? topChat["PlaylistroomId"]
      : topChat["otherUser"]["_id"];
    
    props.senndUserId(
      userName,
      userid,
      new Date().getTime(),
      topChat["PlaylistroomId"]
    );
    
    setUserName(userName);
    setPlaylistRoomId(topChat["PlaylistroomId"]);
    isPlaylistChat.current = topChat["PlaylistroomId"] ? true : false;
    setOpenUser(false);
    setShowNft(false);
    setStatus(
      topChat["PlaylistroomId"] &&
      topChat["blockList"].length > 0 &&
      topChat["blockList"].indexOf(getUserId()) >= 0
        ? "blocked"
        : "active"
    );
    setMore(false);
  }, [chatIndex, topChats, userId, props]);

  return (
    <Box
      className={
        "__chat_container_direct" +
        (songs && songs["songs"].length > 0
          ? " __chat_container_with_song_artist"
          : "")
      }
    >
      <Box className="__chat">
        <Box className="__chat_header">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              position="relative"
            >
              <Typography
                onClick={() => handleTilteClick()}
                title={
                  props["title"] && props["title"].length > 20
                    ? props["title"]
                    : ""
                }
                className="fs-20 text-capitalize _cp"
                sx={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 700,
                  letterSpacing: '-0.5px'
                }}
              >
                {truncate(props["title"], 20)}
              </Typography>

              {/*  */}
              {/* {isPlaylistChat.current && roomid.current ? (
                <Online
                  playListId={roomid.current}
                  onClick={(onlineUsers) => {
                    setOpenPlaylistTip(false);
                    setMore(false);
                    setShowUsers(true);
                    setOnlineUsers(onlineUsers);
                  }}
                  online="true"
                  className="_cp"
                />
              ) : null} */}
            </Stack>
            <CloseIcon
              sx={{ zIndex: "10000", marginLeft: "auto" }}
              className="_cp __chat_close"
              onClick={() => {
                dispatch(hideChat(false));
                props.onOutsideClick();
              }}
              color="default"
            />
          </Stack>
        </Box>
        <Divider className="__chat_header_divider" />
        {!openTip &&
        !openPlaylistTip &&
        !showUsers &&
        !more &&
        isPlaylistChat.current ? (
          <img
            className="_chat_tippers_icon"
            src={Images.chat_drop}
            alt="chat_drop"
            onClick={() => {
              setMore(true);
            }}
          />
        ) : null}
        {openPlaylistTip ? (
          <ChatTip
            songs={[]}
            playlistId={roomid.current}
            onClose={() => setOpenPlaylistTip(false)}
          />
        ) : null}
        {showUsers ? (
          <OnlineUsers
            users={onlineUsers}
            playListId={props["playListId"]}
            onClose={() => setShowUsers(false)}
          />
        ) : null}
        {showNft ? (
          <NftList
            onClose={() => setShowNft(false)}
            fullName={props["title"]}
            toUser={newUser["_id"] ?? props?.senderUserId}
          />
        ) : null}
        {more ? (
          <ChatMoreData
            playlistId={roomid.current}
            onClose={() => setMore(false)}
          />
        ) : null}
        <Stack spacing={1} sx={{ height: "100%" }}>
          {roomId && !openUser ? (
            <Message
              status={status}
              roomId={roomid.current}
              playListId={playlistRoomId}
              type={playlistRoomId ? "group" : "direct"}
              senderUserId={senderUserId.current}
              newMessage={newMessage}
              // clearMsg={() => setNewMessage()}
              close={() => {
                setRoomId(null);
                roomid.current = null;
                setNewMessage({});
              }}
              onChangeStatus={(status) => {
                setStatus(status);
              }}
            />
          ) : (
            <Box>
              <NoData
                lable={
                  !props["senderUserId"]
                    ? t("noData.message10")
                    : t("noData.message9")
                }
              />
            </Box>
            // null
          )}
        </Stack>
        <Box className="__chat_typing">
        </Box>

        {status === "blocked" ? (
          <Stack
            direction="row"
            justifyContent="center"
            align="center"
            className="__chat_send"
          >
            <Typography
              sx={{
                color: "var(--text-secondary, #5a5a5a)",
                display: "flex",
                alignItems: "center",
                cursor: "default",
              }}
            >
              {isPlaylistChat.current
                ? "Blocked from owner"
                : isOwnerId(blockedBy)
                ? "Unblock user"
                : "Blocked"}
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" className="__chat_send">
            {!isPlaylistChat.current && roomid.current ? (
              <img
                aria-label="Gift nft"
                className="__chat_gift _cp"
                title="gift nft"
                src={Images.GIFT}
                alt="gift"
                onClick={() => setShowNft(true)}
                onClose={() => setShowNft(false)}
              />
            ) : null}
            {isPlaylistChat.current || roomid.current ? (
              <>
                <img
                  title="Tip"
                  aria-label="tip"
                  className="__chat_tip _cp"
                  src={Images.tip_hover_player}
                  alt="tip"
                  onClick={() => setOpenTip(true)}
                />
                <Box position="relative" className="__chat_emoji_wrapper">
                  <img
                    aria-label="emoji"
                    title="Open emoji"
                    className="__chat_emoji _cp"
                    src={Images.emoji}
                    alt="emoji"
                    onClick={() => {
                      setOpenEmoji(!openEmoji);
                    }}
                  />
                  {openEmoji && (
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: "40px",
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      <OutsideClickHandler onOutsideClick={() => setOpenEmoji(false)}>
                        <Picker
                          onEmojiClick={onEmojiClick}
                          searchPlaceHolder="Search emoji..."
                          width={350}
                          height={400}
                          previewConfig={{ showPreview: false }}
                        />
                      </OutsideClickHandler>
                    </Box>
                  )}
                </Box>
              </>
            ) : null}

            {roomId ? (
              <ChatInput
                status={status}
                roomId={playlistRoomId ? playlistRoomId : roomId}
                playListId={playlistRoomId}
                type={playlistRoomId ? "group" : "direct"}
                message={message}
                senderUserId={props["senderUserId"]}
                onSendMessage={(msg) => {
                  setNewMessage({ ...msg });
                  setMessage("");
                }}
                cleanEmoji={() => setMessage("")}
              />
            ) : null}
          </Stack>
        )}
      </Box>
      <Box className="__chat_user_container pos_r">
        {isPlaylistChat.current &&
        chatIndex !== null &&
        isOwnerId(topuser.current[chatIndex]?.playlistDetails?.owner) &&
        !isStream &&
        !topuser.current[chatIndex]?.nftDetails?.onSale &&
        !topuser.current[chatIndex]?.nftDetails?.onAuction ? (
          <Stack
            alignItems="center"
            sx={{ paggingTop: "10px", cursor: "pointer" }}
            onClick={
              () => setIsStreamingPopup(true)
              // dispatch(
              //   startStream({
              //     streamData: topuser.current[chatIndex]?.playlistDetails,
              //     title: null,
              //     goal: null,
              //   })
              // )
              // : setIsStreamingPopup(false)
            }
          >
            <img style={{ width: "32px" }} src={Images.streaming} alt="" />
          </Stack>
        ) : null}

        {props?.artistChat ? null : (
          <>
            <Box className="__chat_user_box">
              {load && topChats.length === 0 ? (
                // Show skeleton loader while loading
                <div className="chat-list-skeleton">
                  {[1, 2, 3, 4, 5, 6].map((item) => (
                    <div key={item} className="skeleton-item">
                      <div className="skeleton-avatar"></div>
                      <div className="skeleton-content">
                        <div className="skeleton-name"></div>
                        <div className="skeleton-message"></div>
                      </div>
                      <div className="skeleton-time"></div>
                    </div>
                  ))}
                </div>
              ) : topChats &&
                topChats.map((topChat, index) => (
                  <Box
                    key={index}
                    className="__chat_user_box_user"
                    onClick={() => {
                      console.log('[DM Chat] Chat user clicked', { index, chatIndex, topChat });

                      if (
                        chatIndex === index
                        // ||
                        // (newUser && newUser["_id"] === topChat["otherUser"]["_id"])
                      ) {
                        console.log('[DM Chat] Already viewing this chat, skipping');
                        return;
                      }

                      setNewUser(
                        topChat["otherUser"] ? topChat["otherUser"] : {}
                      );
                      online.current = topChat["otherUser"]
                        ? topChat["ChatroomId"]
                        : null;
                      setChatIndex(index);
                      const temp = topChats;
                      temp[index]["count"] = undefined;
                      if (temp[index]["unseen"])
                        temp[index]["unseen"][userId] = 0;

                      setTopChats([...temp]);
                      setRoomId(null);
                      const userName = topChat["PlaylistroomId"]
                        ? topChat["playlistDetails"]["title"]
                        : fullName(topChat["otherUser"]);
                      const userid = topChat["PlaylistroomId"]
                        ? topChat["PlaylistroomId"]
                        : topChat["otherUser"]["_id"];

                      console.log('[DM Chat] Calling senndUserId callback', { userName, userid, isPlaylist: !!topChat["PlaylistroomId"] });
                      props.senndUserId(
                        userName,
                        userid,
                        new Date().getTime(),
                        topChat["PlaylistroomId"]
                      );
                      setUserName(userName);
                      setPlaylistRoomId(topChat["PlaylistroomId"]);
                      isPlaylistChat.current = topChat["PlaylistroomId"]
                        ? true
                        : false;
                      setOpenUser(false);
                      setShowNft(false);
                      setStatus(
                        topChat["PlaylistroomId"] &&
                          topChat["blockList"].length > 0 &&
                          topChat["blockList"].indexOf(getUserId()) >= 0
                          ? "blocked"
                          : "active"
                      );
                      setMore(false);
                    }}
                  >
                    {topChat["count"] && !topChat["PlaylistroomId"] ? (
                      <Box className="__chat_user_online_count">
                        {topChat["count"]}
                      </Box>
                    ) : topChat["PlaylistroomId"] &&
                      topChat["unseen"] &&
                      topChat["unseen"][userId] ? (
                      <Box className="__chat_user_online_count">
                        {topChat["unseen"][userId]}
                      </Box>
                    ) : null}
                    <img
                      className="avatar"
                      src={
                        topChat["PlaylistroomId"] && topChat["playlistDetails"]
                          ? topChat["playlistDetails"]["GIF"]
                            ? topChat["playlistDetails"]["GIF"]["filePath"]
                            : topChat["playlistDetails"]["thumbnailImg"]
                            ? topChat["playlistDetails"]["thumbnailImg"][
                                "filePath"
                              ]
                            : Images.circle_playlist
                          : topChat["otherUser"] &&
                            topChat["otherUser"]["profileImg"]
                          ? topChat["otherUser"]["profileImg"]["filePath"]
                          : Images.default_user
                      }
                      alt=""
                    />
                    {/* NOTE: compressed online status*/}
                    {topChat["ChatroomType"] === "direct" ? (
                      <Box
                        className="__chat_user_online"
                        sx={{
                          backgroundColor:
                            topChat["ChatroomType"] === "direct" &&
                            topChat["otherUser"] &&
                            topChat["otherUser"]["isOnline"]
                              ? "var(--success-color, #2CF488)"
                              : "rgba(var(--text-secondary-rgb, 153, 153, 153), 0.6)",
                        }}
                      ></Box>
                    ) : null}
                  </Box>
                ))}
            </Box>
            <Box className="___">
              <Box
                className="__chat_user_new"
                onClick={() => {
                  setOpenUser(true);
                }}
              >
                <AddIcon className="__chat_add" sx={{ color: "var(--text-secondary, #999999)" }} />
              </Box>
            </Box>
          </>
        )}

        {load ? <Loader _class="__loader_inside" oldLoader /> : null}
      </Box>
      {openUser ? (
        <ChatUserSearch
          userId={userId}
          playlistId={roomid.current}
          senderUserId={newUser["_id"]}
          userName={userName}
          newUser={newUser}
          handleClose={(userName, userId, user, playlistroomId) =>
            userId && userName
              ? (setOpenUser(false),
                props.senndUserId(
                  userName,
                  userId,
                  new Date().getTime(),
                  playlistroomId
                ),
                setUserName(userName),
                setChatIndex(null),
                setPlaylistRoomId(playlistroomId),
                addNewUser(user, playlistroomId),
                setStatus("active"))
              : handleSelection(false)
          }
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={userName}
          id={isPlaylistChat.current ? roomid.current : props["senderUserId"]}
          open={openTip}
          isArtist={isPlaylistChat.current ? false : true}
          isPlaylist={isPlaylistChat.current ? true : false}
          handleClose={handleTip}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          message={t("loader.message10")}
          _class="__loader_inside"
        />
      ) : null}
      {isStreamingPopup ? (
        <StreamingDetailPoup
          open={isStreamingPopup}
          channelName={playlistRoomId}
          handleClose={(open, title, goal, goalDescription, isNew) =>
            open
              ? (dispatch(
                  startStream({
                    streamData: topuser.current[chatIndex]?.playlistDetails,
                    title: title,
                    goal: goal,
                    goalDescription: goalDescription,
                    isNew: isNew,
                  })
                ),
                setIsStreamingPopup(false))
              : setIsStreamingPopup(false)
          }
        />
      ) : null}
    </Box>
  );
}
